import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { ProtectedRoute, AdminRoute, OwnerRoute } from "./components/ProtectedRoute";
import AuthCallback from "./components/AuthCallback";
import BottomNav from "./components/BottomNav";
import { Toaster } from "./components/ui/sonner";

// Pages
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import HomePage from "./pages/HomePage";
import ProgramsPage from "./pages/ProgramsPage";
import SubscriptionsPage from "./pages/SubscriptionsPage";
import MyCarPage from "./pages/MyCarPage";
import HistoryPage from "./pages/HistoryPage";
import AccountPage from "./pages/AccountPage";
import PaymentPage from "./pages/PaymentPage";
import ReferralsPage from "./pages/ReferralsPage";
import VIPCardPage from "./pages/VIPCardPage";
import OwnerConsolePage from "./pages/OwnerConsolePage";
import KioskPage from "./pages/KioskPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";
import AdminPage from "./pages/AdminPage";
import GlobalPopups from "./components/GlobalPopups";
import EduPopup from "./components/EduPopup";
import DiscoverPage from "./pages/DiscoverPage";
import PremiumServicePage from "./pages/PremiumServicePage";

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id during render (NOT in useEffect)
  // This prevents race conditions by processing new session_id FIRST
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/registrohu" element={<RegisterPage />} />
        {/* Iter18 Task 10 — public read-only TV view (no auth) */}
        <Route path="/kiosk" element={<KioskPage />} />
        {/* Iter22 — Detailing public landing (browse without login; booking auto-redirects to /login) */}
        {/* Iter24 F1+F2 — split into two separate pages */}
        <Route path="/liquid-glass" element={<PremiumServicePage category="liquid_glass" />} />
        <Route path="/detailing-i-plote" element={<PremiumServicePage category="detailing_i_plote" />} />
        {/* Legacy alias /detailing → Liquid Glass (most common premium service) */}
        <Route path="/detailing" element={<PremiumServicePage category="liquid_glass" />} />
        {/* Iter23 G5 — Zbulo (educational videos) */}
        <Route path="/zbulo" element={<DiscoverPage />} />
        <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
        <Route path="/programs" element={<ProtectedRoute><ProgramsPage /></ProtectedRoute>} />
        <Route path="/subscriptions" element={<ProtectedRoute><SubscriptionsPage /></ProtectedRoute>} />
        <Route path="/my-car" element={<ProtectedRoute><MyCarPage /></ProtectedRoute>} />
        <Route path="/history" element={<ProtectedRoute><HistoryPage /></ProtectedRoute>} />
        <Route path="/account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
        <Route path="/payment" element={<ProtectedRoute><PaymentPage /></ProtectedRoute>} />
        <Route path="/referrals" element={<ProtectedRoute><ReferralsPage /></ProtectedRoute>} />
        <Route path="/vip-card" element={<ProtectedRoute><VIPCardPage /></ProtectedRoute>} />
        <Route path="/owner-console" element={<OwnerRoute><OwnerConsolePage /></OwnerRoute>} />
        <Route path="/payment-success" element={<ProtectedRoute><PaymentSuccessPage /></ProtectedRoute>} />
        <Route path="/payment-cancel" element={<ProtectedRoute><PaymentCancelPage /></ProtectedRoute>} />
        <Route path="/admin" element={<AdminRoute><AdminPage /></AdminRoute>} />
        {/* Iter33 — retired /ceo, /manager, /employee (and any unknown path) fall back to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <BottomNav />
      <GlobalPopups />
      {/* Iter23 G5 — Educational popup (idle 30s, 3-day cooldown) */}
      <EduPopup />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
